// extracted by mini-css-extract-plugin
export default {"wrapper":"recurringexpenses_wrapper__mn-HO","header":"recurringexpenses_header__ZT+G+"};